/* This file was generated automatically. Do not edit manually. */

export enum ProfileDataDiscriminator {
    PersonalProfile = 'PersonalProfile',
    EnterpriseProfile = 'EnterpriseProfile',
    PlatformProfile = 'PlatformProfile',
    AnonymousProfile = 'AnonymousProfile',
    JobProfile = 'JobProfile',
    SystemProfile = 'SystemProfile',
    IntegrationProfile = 'IntegrationProfile',
}
